import {format} from 'date-fns'
import {KTIcon} from '../../../../_metronic/helpers'
import clsx from 'clsx'
import {useChatContext} from '../Context'
import {Message} from '../types'
import {useEffect} from 'react'
import {useInView} from 'react-intersection-observer'

const MsgTypeIcon = ({msgType}: {msgType: string}) => (
  <KTIcon
    iconName={msgType === 'information' ? 'information-5' : 'question'}
    className={clsx('fs-3 pe-1', msgType === 'information' ? 'text-warning' : 'text-danger')}
  />
)

const MessageItem = ({
  msg,
  openMessage,
  selectedOldChat,
}: {
  msg: Message
  openMessage: () => void
  selectedOldChat: Message | null
}) => {
  const isSelectedChat = selectedOldChat ? selectedOldChat?.id === msg.id : false

  return (
    <div
      className={clsx(
        'bg-secondary-subtle rounded-3 ps-3 pe-5 py-6 msg-item bg-hover-light-primary',
        isSelectedChat && 'bg-active-opacity-10 bg-primary active'
      )}
      style={{
        cursor: 'pointer',
      }}
      onClick={openMessage}
    >
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <div
          className={clsx('text-truncate ps-1 lead fs-6', isSelectedChat && 'text')}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {msg.content}
        </div>

        <div className="small mt-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <MsgTypeIcon msgType={msg.messageType} />{' '}
            <span className="text-capitalize text-body">{msg.messageType}</span>
          </div>
          <span className="fw-light text-gray-600">
            {format(msg.sentAt!, 'MM/dd/yyyy, hh:mm aa')}
          </span>
        </div>
      </div>
    </div>
  )
}

// const MsgLoader = forwardRef(
//   (
//     {
//       isFetchingMoreMessages,
//       msgCount,
//       hasMoreMessages,
//     }: {
//       isFetchingMoreMessages: boolean
//       msgCount: number
//       hasMoreMessages: boolean
//     },
//     ref: React.Ref<any>
//   ) => {
//     if (isFetchingMoreMessages) {
//       return (
//         <div style={{height: '40px'}}>
//           <span className="stick-loader" />
//         </div>
//       )
//     }

//     if (msgCount > 10 && !hasMoreMessages) {
//       return <div className="text-center lead text-gray-600">You're all caught up!</div>
//     }

//     if (hasMoreMessages && !isFetchingMoreMessages) return <div ref={ref}></div>

//     return null
//   }
// )

function ChatHistory() {
  const {data, selectedOldChat, selectOldChat, messageDataHelpers} = useChatContext()

  const {hasMoreMessages, fetchMoreMessages, isFetchingMoreMessages} = messageDataHelpers

  const {ref, inView} = useInView()

  useEffect(() => {
    if (inView && hasMoreMessages && !isFetchingMoreMessages) {
      fetchMoreMessages()
    }
  }, [inView, hasMoreMessages, isFetchingMoreMessages, fetchMoreMessages])

  const {messages} = data

  return (
    <div className="d-flex flex-column gap-5">
      {messages.map((msg) => (
        <MessageItem
          openMessage={() => selectOldChat(msg)}
          key={msg.id}
          msg={msg}
          selectedOldChat={selectedOldChat}
        />
      ))}
      {isFetchingMoreMessages && (
        <div style={{height: '45px'}}>
          <span className="stick-loader"></span>
        </div>
      )}
      {/* Empty div with 40px height when no conditions are met */}
      {!isFetchingMoreMessages && hasMoreMessages && <div style={{height: '40px'}}></div>}

      {messages.length > 10 && !hasMoreMessages && (
        <div className="text-center lead text-gray-600">You're all caught up!</div>
      )}
      {hasMoreMessages && !isFetchingMoreMessages && <div ref={ref}></div>}
    </div>
  )
}

export default ChatHistory
